export const SUCCESS_CODE = 200;
export const SERVER_ERROR_CODE = 500;
export const BAD_REQUEST_CODE = 400;
export const NO_AUTH_CODE = 401;
export const CONFLICT_CODE = 409;